export default __webpack_public_path__ + "static/media/manhappy1.5a94ee95.gif";